import React, { useState, useEffect } from "react";
import { useTimer } from "use-timer";

import ValueDisplay from "components/ValueDisplay";
import TextInput from "components/TextInput";
import Feedback from "components/Feedback";

import "css/Game.css";

import { getWords } from "utils/wordUtils";
import { log } from "utils/logger";

const SECONDS = 60;

export default function Game({ setFloatingWords, setFinalStats }) {
  const [hasTyped, setHasTyped] = useState(false);
  const [index, setIndex] = useState(0);
  const [words, setLocalWords] = useState([]);
  const [correctTypes, setCorrectTypes] = useState(0);
  const [totalTypes, setTotalTypes] = useState(0);
  const [resetTextInput, setResetTextInput] = useState(() => {});

  const { time, start, reset, status } = useTimer({
    initialTime: SECONDS,
    endTime: 0,
    timerType: "DECREMENTAL",
    interval: 1000,
  });

  const isRunning = status === "RUNNING";

  useEffect(() => {
    setLocalWords(getWords());
  }, []);

  useEffect(() => {
    if (words.length - index < 5) {
      setLocalWords(words.concat(getWords()));
    }
  }, [words, index]);

  let timeValue = SECONDS;
  if (time > 0) {
    timeValue = time;
  }
  if (hasTyped && !isRunning) {
    timeValue = 0;
  }

  const accuracy =
    totalTypes === 0
      ? "-"
      : Math.round((correctTypes * 100) / totalTypes) + "%";

  useEffect(() => {
    if (hasTyped && !isRunning && time === 0) {
      log("finish_game");
      setFinalStats({
        accuracy,
        count: index,
        onReset: () => {
          reset();
          resetTextInput?.();
          setLocalWords(getWords());
          setIndex(0);
          setCorrectTypes(0);
          setTotalTypes(0);
          setHasTyped(false);
        },
      });
    }
  }, [
    resetTextInput,
    reset,
    time,
    accuracy,
    index,
    setFinalStats,
    hasTyped,
    isRunning,
  ]);

  return (
    <div className="gameContainer">
      <div className="valuesContainer">
        <ValueDisplay text="Time" value={timeValue} />
        <ValueDisplay text="Words" value={index} />
        <ValueDisplay text="Accuracy" value={accuracy} />
      </div>
      <TextInput
        canType={isRunning}
        correctWord={words[index]}
        hasTyped={hasTyped}
        words={words.slice(index + 1)}
        onType={(correct) => {
          setTotalTypes(totalTypes + 1);
          if (correct) {
            setCorrectTypes(correctTypes + 1);
          }
        }}
        onFirstType={() => {
          setHasTyped(true);
          start();
        }}
        onFinishWord={(word) => {
          log("type_word");
          setIndex(index + 1);
          setFloatingWords([...words.slice(0, index + 1)]);
        }}
        setReset={setResetTextInput}
      />
      <Feedback />
    </div>
  );
}
